import { Lock, MessageCircle } from "lucide-react";
import { AreaLayout } from "@/components/AreaLayout";

const CATEGORIAS = ["Mi paso", "Un logro", "Una dificultad", "Una reflexión"];

export default function Comunidad() {
  return (
    <AreaLayout>
      <p className="eyebrow mb-4">Comunidad</p>
      <h1 className="font-display text-4xl text-[#102B5B] sm:text-5xl" style={{ fontWeight: 600 }} data-testid="comunidad-title">
        No tienes que recorrerlo sola.
      </h1>

      <div className="mt-8 flex flex-wrap gap-2" data-testid="comunidad-categorias">
        {CATEGORIAS.map((c) => (
          <span key={c} className="rounded-full border border-[#C5D7F4] bg-[#F4F7FD] px-4 py-2 text-sm font-semibold text-[#1F4C98]">
            {c}
          </span>
        ))}
      </div>

      {/* Compositor (diseñado, inactivo hasta tener acceso privado) */}
      <div className="mt-8 soft-card p-6" data-testid="comunidad-compositor">
        <p className="text-base font-semibold text-[#171A20]">Comparte tu avance</p>
        <div className="mt-3 rounded-2xl border border-dashed border-[#D6DAE0] bg-[#F4F7FD] p-5 text-base text-[#626B79]">
          Cuenta qué paso has dado o qué dificultad encuentras…
        </div>
        <button
          type="button"
          disabled
          data-testid="comunidad-compartir"
          className="mt-4 inline-flex cursor-not-allowed items-center gap-2 rounded-full border border-[#D6DAE0] bg-white px-6 py-2.5 text-base font-semibold text-[#626B79]"
        >
          <Lock size={16} /> Compartir avance · Próximamente
        </button>
        <p className="mt-2 text-sm text-[#626B79]">
          Podrás compartir cuando exista el acceso privado adecuado.
        </p>
      </div>

      {/* Estado vacío */}
      <div className="mt-8 rounded-3xl border border-[#E6EEFA] bg-[#F4F7FD] p-10 text-center" data-testid="comunidad-empty">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#E6EEFA] text-[#275FBE]">
          <MessageCircle size={26} />
        </span>
        <p className="mt-4 text-lg text-[#343A46]">
          Cuando la comunidad empiece a compartir, lo verás aquí.
        </p>
      </div>
    </AreaLayout>
  );
}
